import { Navigate, Outlet } from "react-router-dom";
import { Backdrop, CircularProgress } from "@mui/material";
import { useAuthStatus } from "@mirage/hooks/useAuthStatus";

interface ProtectedRouteProps {
    redirectTo?: string;
    customAllowCondition?: boolean;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ redirectTo, customAllowCondition = true }) => {
    const { loggedIn, checkingStatus } = useAuthStatus();
    if (checkingStatus) {
        return (
            <Backdrop sx={{ color: "#fff" }} open={true}>
                <CircularProgress color="inherit" />
            </Backdrop>
        );
    }
    if (loggedIn && customAllowCondition) {
        return <Outlet />;
    }
    return <Navigate to={redirectTo ? redirectTo : "/"} />;
};
